import { useAuth0 } from '@auth0/auth0-react';
import { namespace } from '../constants/text-values';
import { findRoles } from '../utils/filtering';

const rolesToAccessPresaleReport = [
  'Project Manager',
  'Delivery Manager',
  'Head of Delivery',
  'Head of Accountant',
  'Accountant',
  'CEO',
] as const;

const useRolesToAccessPresaleReport = () => {
  const { user } = useAuth0();
  if (!user) return false;
  const extendedRole = findRoles(
    user[`${namespace}/roles`],
    rolesToAccessPresaleReport,
  );

  return extendedRole;
};

export default useRolesToAccessPresaleReport;
